import { useState } from "react";
import axios from "axios";

const API = "https://tribaltech-backend.onrender.com";

const PLANS = [
  { id: "starter", name: "Starter", price: "$29", desc: "Fingerprinting + 30+ piracy-platform crawler + auto DMCA", color: "#7B5EA7" },
  { id: "pro", name: "Pro", price: "$59", desc: "Everything in Starter + 15 master slots + priority enforcement + X/social takedowns + Dropbox/Drive (coming soon)", color: "#0D9488" },
  { id: "clean_slate", name: "Clean Slate", price: "$49", desc: "Former creators — legacy content removal", color: "#378ADD" },
];

export default function Signup() {
  const params = new URLSearchParams(window.location.search);
  const defaultPlan = params.get("plan") || "starter";
  const defaultReferral = (params.get("ref") || "").toUpperCase();

  const [step, setStep] = useState(1);
  const [plan, setPlan] = useState(defaultPlan);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [referralCode, setReferralCode] = useState(defaultReferral);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const selectedPlan = PLANS.find(p => p.id === plan) || PLANS[0];

  const handleSignup = async () => {
    if (!email || !password) { setError("Email and password are required"); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters"); return; }
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/api/auth/signup`, {
        email, password, username, plan,
        referral_code: referralCode || undefined,
      });
      localStorage.setItem("tribal_token", data.token);
      localStorage.setItem("tribal_user", JSON.stringify(data.user));
      // Now go to Stripe checkout for the selected plan
      const { data: checkout } = await axios.post(
        `${API}/api/billing/checkout`,
        { plan },
        { headers: { Authorization: `Bearer ${data.token}` } }
      );
      window.location.href = checkout.url;
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px", fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input { background: rgba(255,255,255,0.05); border: 0.5px solid rgba(255,255,255,0.15); border-radius: 8px; padding: 12px 16px; font-size: 14px; color: #f0ede8; font-family: inherit; width: 100%; outline: none; transition: border-color 0.2s; }
        input:focus { border-color: rgba(123,94,167,0.6); }
        .btn-primary { background: #7B5EA7; color: #fff; border: none; border-radius: 8px; padding: 14px; font-size: 15px; font-weight: 500; cursor: pointer; font-family: inherit; width: 100%; transition: background 0.2s; }
        .btn-primary:hover { background: #6a4f93; }
        .btn-primary:disabled { background: rgba(123,94,167,0.4); cursor: not-allowed; }
        .plan-card { border: 0.5px solid rgba(255,255,255,0.1); border-radius: 12px; padding: 16px; cursor: pointer; transition: all 0.2s; background: rgba(255,255,255,0.02); }
        .plan-card:hover { border-color: rgba(123,94,167,0.4); }
        .plan-card.selected { border-color: #7B5EA7; background: rgba(123,94,167,0.08); }
      `}</style>

      <div style={{ width: "100%", maxWidth: 480 }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 24, textDecoration: "none" }}>
            <div style={{ width: 28, height: 28, borderRadius: 6, background: "#7B5EA7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 600, color: "#fff" }}>C</div>
            <span style={{ fontSize: 15, fontWeight: 500, color: "#f0ede8" }}>Creator Protect</span>
          </a>
          <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, fontWeight: 400, marginBottom: 8 }}>
            Start your free trial
          </h1>
          <p style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", lineHeight: 1.6 }}>
            3 days free — no credit card charged until day 4.<br />Cancel anytime before then.
          </p>
        </div>

        {/* Step 1 — Plan selection */}
        {step === 1 && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(240,237,232,0.4)", letterSpacing: "0.08em", marginBottom: 14 }}>CHOOSE YOUR PLAN</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
              {PLANS.map(p => (
                <div key={p.id} className={`plan-card ${plan === p.id ? "selected" : ""}`} onClick={() => setPlan(p.id)}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: plan === p.id ? p.color : "rgba(255,255,255,0.2)", transition: "background 0.2s" }} />
                      <span style={{ fontSize: 14, fontWeight: 500 }}>{p.name}</span>
                    </div>
                    <span style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20 }}>{p.price}<span style={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif", color: "rgba(240,237,232,0.4)" }}>/mo</span></span>
                  </div>
                  <div style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", paddingLeft: 18 }}>{p.desc}</div>
                </div>
              ))}
            </div>
            <button className="btn-primary" onClick={() => setStep(2)}>
              Continue with {selectedPlan.name} — {selectedPlan.price}/mo →
            </button>
            <p style={{ textAlign: "center", fontSize: 12, color: "rgba(240,237,232,0.3)", marginTop: 12 }}>First 3 days completely free</p>
          </div>
        )}

        {/* Step 2 — Account creation */}
        {step === 2 && (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24, background: "rgba(123,94,167,0.08)", border: "0.5px solid rgba(123,94,167,0.2)", borderRadius: 10, padding: "12px 16px" }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: selectedPlan.color }} />
              <span style={{ fontSize: 13, color: "rgba(240,237,232,0.7)" }}>{selectedPlan.name} plan — {selectedPlan.price}/mo</span>
              <span onClick={() => setStep(1)} style={{ marginLeft: "auto", fontSize: 12, color: "#7B5EA7", cursor: "pointer" }}>Change</span>
            </div>

            {error && (
              <div style={{ background: "rgba(226,75,74,0.1)", border: "0.5px solid rgba(226,75,74,0.3)", borderRadius: 8, padding: "12px 16px", marginBottom: 20, fontSize: 13, color: "#f09595" }}>
                {error}
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 24 }}>
              <div>
                <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Email address</label>
                <input type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Password</label>
                <input type="password" placeholder="Min. 8 characters" value={password} onChange={e => setPassword(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Creator username <span style={{ color: "rgba(240,237,232,0.25)" }}>(optional)</span></label>
                <input type="text" placeholder="e.g. TribalBBC" value={username} onChange={e => setUsername(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Referral code <span style={{ color: "rgba(240,237,232,0.25)" }}>(optional)</span></label>
                <input type="text" placeholder="From a creator who invited you" value={referralCode} onChange={e => setReferralCode(e.target.value.toUpperCase())} style={{ letterSpacing: 2, fontFamily: 'monospace' }} />
              </div>
            </div>

            <button className="btn-primary" onClick={handleSignup} disabled={loading}>
              {loading ? "Creating your account..." : "Start free trial — no charge for 3 days"}
            </button>

            <p style={{ textAlign: "center", fontSize: 12, color: "rgba(240,237,232,0.3)", marginTop: 16, lineHeight: 1.6 }}>
              By signing up you agree to our Terms of Service.<br />
              Your card won't be charged until your trial ends.
            </p>
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 28, fontSize: 13, color: "rgba(240,237,232,0.35)" }}>
          Already have an account? <a href="/login" style={{ color: "#7B5EA7" }}>Sign in</a>
        </div>
      </div>
    </div>
  );
}
